import coreOptions from './coreOptions';
import { addPresetOptions } from 'pro-gallery-lib';
import { addCustomPresetStyles } from './customPresetProcessor';
var isHorizontalInfoCompatibleLayout = function (options) {
    var defaultGroupSize = coreOptions.groupSize;
    var galleryLayout = options.galleryLayout, scrollDirection = options.scrollDirection, isVertical = options.isVertical, designedPresetId = options.designedPresetId, isMobile = options.isMobile, groupSize = options.groupSize;
    var baseSP = {
        galleryLayout: galleryLayout,
        scrollDirection: scrollDirection,
        isVertical: isVertical,
        groupSize: typeof groupSize === 'undefined' ? defaultGroupSize : groupSize,
        designedPresetId: typeof designedPresetId === 'undefined' ? -1 : designedPresetId,
    };
    var sp;
    if (Number(baseSP['designedPresetId']) >= 1) {
        sp = addCustomPresetStyles({
            styles: baseSP,
            presetId: designedPresetId,
            isMobile: isMobile,
        });
    }
    else {
        sp = addPresetOptions(baseSP);
    }
    var res = Number(sp['scrollDirection']) === 0 &&
        Number(sp['groupSize']) === 1 &&
        sp['isVertical'] === true;
    return res;
};
export { isHorizontalInfoCompatibleLayout };
//# sourceMappingURL=proGalleryStyleBuilderUtils.js.map